import React from 'react';
import { FileTextIcon, ShieldCheckIcon, HardHatIcon, SearchCheckIcon, ClockIcon, ClipboardListIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const approachItems = [{
  key: 'approach.item1',
  Icon: FileTextIcon
}, {
  key: 'approach.item2',
  Icon: ShieldCheckIcon
}, {
  key: 'approach.item3',
  Icon: HardHatIcon
}, {
  key: 'approach.item4',
  Icon: SearchCheckIcon
}, {
  key: 'approach.item5',
  Icon: ClockIcon
}, {
  key: 'approach.item6',
  Icon: ClipboardListIcon
}];
export function Approach() {
  const {
    t
  } = useLanguage();
  return <section id="approach" className="w-full bg-graphite py-20 sm:py-28" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <ScrollFadeIn data-id="element-50">
          <div className="mb-4" data-id="element-51">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-52">
              {t('approach.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-53">
            {t('approach.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-54">
          {approachItems.map((item, i) => <ScrollFadeIn key={item.key} delay={i * 60} data-id="element-55">
              <div className="flex items-start gap-4 p-5 bg-navy border border-slate-700/50 rounded h-full" data-id="element-56">
                <div className="shrink-0 w-9 h-9 flex items-center justify-center rounded bg-electric/10" data-id="element-57">
                  <item.Icon className="w-4 h-4 text-electric" data-id="element-58" />
                </div>
                <span className="text-sm text-slate-300 leading-relaxed pt-1.5" data-id="element-59">
                  {t(item.key)}
                </span>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}